import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
    Button,
    Grid,
    TableContainer,
    Divider,
    Typography,
    TableCell,
    TableRow,
    TableHead,
    TableBody,
    Table,
} from "@material-ui/core";
import moment from "moment";
import Image from "../../../assets/LOGOS_RGB-01.png";


const useStyles = makeStyles((theme) => ({
    form: {
        display: "flex",
        flexDirection: "column",
        margin: "20px",
        padding: 30,
    },
    align: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    alignDatos: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start"
    },
    text: {
        width: "100%",
        border: "1px solid #ccc",
        borderRadius: ".3em",
        textAlign: "center",
    },
    textObservaciones: {
        width: "100%",
        border: "1px solid #ccc",
        borderRadius: ".5em",
        textAlign: "left",
        padding: "1em",
        wordBreak: "break-word",
    },
    imageInherit: {
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: 150,
        margin: "-30px 0 -50px"
    },
}));

export const FormatoImpresionTicket = ({
    handleClose,
    handlePrintRow,
    componentRef,
    modal,
    practicas,
    item
}) => {
    const classes = useStyles();


    let totalValorPracticas = 0;

    // Calcula el total sumando el valor de cada práctica
    practicas.forEach((practica) => {
        totalValorPracticas += practica.valorCoseguro;
    });

    return (
        <TableContainer className={classes.form}>
            <Grid container spacing={2} ref={componentRef}>
                <Grid item xs={12} className={classes.logo}>
                    <Grid container justify="flex-end">
                        <img src={Image} alt="Logo" style={{ width: '300px', height: 'auto' }} />
                    </Grid>
                </Grid>
                <Grid item xs={12} className={classes.align}>
                    <Typography style={{ fontSize: "1.5em" }} color="primary">
                        ATENCIÓN BENEFICIARIA/O 
                    </Typography>
                </Grid>
                <Grid item xs={12} style={{ marginTop: "1em" }}>
                    <Divider />
                </Grid>
                <Grid item xs={12}>
                    <Grid container>
                        <Grid container>
                            <Grid item xs={12} className={classes.alignDatos}>
                                <Typography style={{ fontSize: "1.5em" }} color="primary">
                                    Fecha de Impresión: {moment().format("DD/MM/YYYY")}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} className={classes.alignDatos}>
                                <Typography style={{ fontSize: "1.5em" }} color="primary">
                                    Id Agenda: {item?.idAgenda}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} className={classes.alignDatos}>
                                <Typography style={{ fontSize: "1.5em" }} color="primary">
                                    Profesional: {item?.efectorRed?.razonSoci}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} className={classes.alignDatos}>
                                <Typography style={{ fontSize: "1.5em" }} color="primary">
                                    Beneficiaria/o: {item?.afiliadoExterno?.apellidoNombre}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} className={classes.alignDatos}>
                                <Typography style={{ fontSize: "1.5em" }} color="primary">
                                    Carnet: {item?.afiliadoExterno?.carnet}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Práctica</TableCell>
                            <TableCell align="right">Cantidad</TableCell>
                            <TableCell align="right">Valor</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {/* Mover el bucle de mapeo de las prácticas aquí */}
                        {practicas.map((practica, index) => (
                            <TableRow key={index}>
                                <TableCell>{`${practica?.nomencladorNacional?.codNom} - ${practica?.nomencladorNacional?.desNom}`}</TableCell>
                                <TableCell align="right">{practica?.cant}</TableCell>
                                <TableCell align="right">{`$ ${practica?.valorCoseguro}`}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
                <Grid item xs={12}>
                    <Grid container>
                        <Grid container>
                            <Grid item xs={12} >
                                <Typography style={{ textAlign: 'right' }}>Total: ${totalValorPracticas.toFixed(2)}</Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} style={{ marginBottom: "6em" }}>
                    <Divider />
                </Grid>
                <Grid item xs={12}>
                    <Grid container>
                        
                            <Grid item xs={6} className={classes.align}>
                                <Typography style={{ fontSize: "1.5em" }} color="primary">
                                    Firma Profesional
                                </Typography>
                            </Grid>
                            <Grid item xs={6} className={classes.align}>
                                <Typography style={{ fontSize: "1.5em" }} color="primary">
                                    Firma Beneficiaria/o
                                </Typography>
                            </Grid>
                       
                    </Grid>
                </Grid>
                <Grid item xs={12} style={{ marginBottom: "2em" }}>
                    <Divider />
                </Grid>
            </Grid>
            {modal && (
                <Grid
                    item
                    xs={12}
                    style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        marginTop: "1em",
                    }}
                >
                    <Button
                        style={{ marginRight: 5 }}
                        onClick={handleClose}
                        variant="contained"
                        color="primary"
                    >
                        Cancelar
                    </Button>
                    <Button
                        onClick={handlePrintRow}
                        variant="contained"
                        color="primary"
                        autoFocus
                    >
                        Imprimir
                    </Button>
                </Grid>
            )}
        </TableContainer>
    )
}
